export interface BackgroundCheckTest {
    useTestData: boolean;
    testData: {
        SUPERVAL: 'CLEAN' | 'DIRTY';
        SSNVER: 'CLEAN' | 'DIRTY';
        NWSEXVAL: 'CLEAN' | 'DIRTY';
        OFAC: 'CLEAN' | 'DIRTY';
    };
}

const testDataValues = [
    { value: 'CLEAN', label: 'CLEAN' },
    { value: 'DIRTY', label: 'DIRTY' },
];

export const backgroundCheckTestForm = {
    type: 'form',
    children: [
        {
            type: 'form.checkbox',
            key: 'useTestData',
            label: 'Use Test Data',
        },
        {
            type: 'form.radio',
            key: 'testData.SUPERVAL',
            label: 'SUPERVAL',
            values: testDataValues,
        },
        {
            type: 'form.radio',
            key: 'testData.SSNVER',
            label: 'SSNVER',
            values: testDataValues,
        },
        {
            type: 'form.radio',
            key: 'testData.NWSEXVAL',
            label: 'NWSEXVAL',
            values: testDataValues,
        },
        {
            type: 'form.radio',
            key: 'testData.OFAC',
            label: 'OFAC',
            values: testDataValues,
        },
    ],
};

export const defaultBackgroundCheckTest: BackgroundCheckTest = {
    useTestData: true,
    testData: {
        SUPERVAL: 'DIRTY',
        SSNVER: 'DIRTY',
        NWSEXVAL: 'DIRTY',
        OFAC: 'DIRTY',
    },
};
